/**
 * Decode the payload of a JWT without verifying its signature.
 * Only suitable for extracting claims client-side (e.g. reading the org ID
 * from an invitation token) — never use this for security decisions.
 */
export function decode(token: string): Record<string, unknown> | null {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
